const jobs = {
  bulk: {

    table: {
      direction: {
        to: 'פיזור',
        from: 'איסוף',
        both: 'איסוף & פיזור',
      },
    },

    direction: {
      label: 'כיוון',
      to: 'לעבודה',
      from: 'מהעבודה',
      both: 'לעבודה & מהעבודה',
    },

    form: {
      information: {
        passengers: {
          header: 'בחר עובדים',
          fields: {
            passengers: 'עובדים',
          },
        },

        details: {
          fields: {
            direction: 'בחר כיוון',
            shift: 'שעות עבודה'
          },
        },
        locations: {
          header: 'מקום עבודה',
          fields: {
            locations: 'בחר מקום עבודה'
          }
        },
      },
    },
  },
};

export default jobs;
